import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Int_TableColumn, TABLE_COLUMN_TYPE } from "../../../models/components";
import { FormsModule } from "@angular/forms";
import { DateToTimeAgo } from "../../../pipes/date-time-ago.pipe";
import { DomSanitizerPipe } from "../../../pipes/dom-sanitizer.pipe";

@Component({
  selector: "mobi-office-lib-table-columns-view",
  imports: [CommonModule, FormsModule, DateToTimeAgo, DomSanitizerPipe],
  templateUrl: "./table-columns-view.component.html",
  styleUrl: "./table-columns-view.component.scss",
})
export class TableColumnsViewComponent {
  @Input({ required: true }) item!: any;
  @Input({ required: true }) column!: Int_TableColumn;

  readonly TABLE_COLUMN_TYPE = TABLE_COLUMN_TYPE;

  getColumnValue(column: Int_TableColumn, item: any): any {
    return column.viewFunction ? column.viewFunction(item) : item[column.viewKey];
  }
}
